import { Typo3SectionSpotSanityContentVideo } from '@/types/typo3'
import { SectionVideoProps } from '@/ui/Sections/SectionVideo/type'

const toSectionVideo = ({
  section
}: {
  section: Typo3SectionSpotSanityContentVideo
}) =>
  ({
    section: section,
    sectionHeaderData: {
      title: section?.content?.title,
      titleLayout: section?.content?.titleLayout,
      overline: section?.content?.overline
    },
    videos: section?.content?.videos?.map((video) => ({
      src: video?.publicUrl,
      provider: video?.properties?.extension
    }))
  }) as SectionVideoProps

export default toSectionVideo
